/**
 * Resource chuyển khoản kho bạc
 * NMDUC1 27/4/2023
 */
export default {
  Title: 'Chuyển khoản kho bạc',
  DetailTitle: 'Chuyển khoản kho bạc',
  DetailTitleDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
  AccountingObjectReceive: 'Người nhận',
  Name: 'Họ tên',
  Address: 'Địa chỉ',
  AccountBank: 'TKKB',
  AccountBankTitle: 'Tài khoản kho bạc',
  Description: 'Diễn giải',
  Include: 'Kèm theo',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày CT',
  RefDateTitle: 'Ngày chứng từ',
  PostedDate: 'Ngày HT',
  PostedDateTitle: 'Ngày hạch toán',
  RefNo: 'Số CT',
  RefNoTitle: 'Số chứng từ',
  VoucherNo: 'Số GR',
  VoucherNoTitle: 'Số giấy rút',
  ThirdRefNo: 'Số CKC',
  ThirdRefNoTitle: 'Số cam kết chi',
  ReceiveAccountTitle: 'Tài khoản đơn vị nhận tiền',
  ReceiveAccount: 'Tài khoản nhận',
  PaymentAccountTitle: 'Tài khoản đơn vị rút dự toán',
  PaymentAccount: 'Tài khoản chi',
  Contract: 'Hợp đồng'
};
